import {
  CHANGE_TOKEN,
  CHANGE_ACCESS_TOKEN,
  CHANGE_FCM_TOKEN,
  CHANGE_JWT_TOKEN,
  RESET_TOKEN_STORE,
} from "../actions/token";

export default function token(state = null, action) {
  switch (action.type) {
    case CHANGE_TOKEN:
      return { ...state, token: action.token };
    case CHANGE_ACCESS_TOKEN:
      return { ...state, accessToken: action.accessToken };
    case CHANGE_FCM_TOKEN:
      return { ...state, fcmToken: action.fcmToken };
    case CHANGE_JWT_TOKEN:
      return { ...state, jwt: action.jwt };
    case RESET_TOKEN_STORE:
      return {}
    default:
      return state;
  }
}
